<template>
  <div class="add-task">
    <el-dialog :visible.sync="currentValue" v-if="currentValue" width="762px" top="auto" custom-class="task-dialog" :show-close="false" :close-on-click-modal="false" >
      <template slot="title">
        <div class="task-head">
          <div class="task-head-left">
            <div class="task-head-in only-one">
              <span>任务详情</span>
            </div>
          </div>
          <div class="task-head-right" v-if="!loading">
            <el-tooltip class="item" effect="dark" content="关闭" placement="bottom">
              <i class="icon iconfont iconicon_close1" @click="currentValue = false"></i>
            </el-tooltip>
          </div>
        </div>
        <div class="tip-gre">项目模版部分功能不可用</div>
      </template>
      <div class="task-panel" v-loading="viewLoading || loading">
        <div class="task-panel-left" v-if="!viewLoading">
          <TaskTitle :editData="editData" :taskName.sync="form.task_name" :taskStatus.sync="form.task_stage" :edit="true"></TaskTitle>
          <FormTemp title="优先级" icon="iconicon_priority">
            <LevelStatus v-model="form.sort_rule_id" :sortList="sortList" />
          </FormTemp>
          <FormTemp title="执行人" icon="iconicon_executor">
            <Executor @changeRunMan="changeRunMan" v-model="form.executor" :defaultValue="form.executor" :projectId="project_id" :isTemplate="true"></Executor>
          </FormTemp>
          <FormTemp title="参与人" icon="iconicon_participant">
            <Participant ref="ParticipantTemp" v-model="form.task_members" :defaultValue="form.task_members" :projectId="project_id" :taskId="taskId" :lockUid="lockUid" :isTemplate="true"></Participant>
          </FormTemp>
          <FormTemp title="完成日期" icon="iconicon_time1">
            <RangeTime v-model="timeRange" />
          </FormTemp>
          <template v-if="dataset.task_template_content">
            <FormTemp v-for="(item) in dataset.task_template_content.template_standard_components" :key="item.component_code + item.component_name_in_template" :icon="keyIcon[item.component_code] || 'iconicon_custom_field'" :title="item.component_name_in_template"  v-if="item.is_show">
              <component :item="item" :is="item.component_code" v-model="form[`${getketText(item)}`]" :projectId="project_id" :config="getTempConfig(item)" :memberList="memberList" :defaultValue="getTemplateDefaultValue(item)" :getketText="getketText" :isTemplate="true"></component>
            </FormTemp>
          </template>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <span class="cancel text-btn-active" @click="currentValue = false">取消</span>
        <!-- <wf-button plain style="margin-right:24px;" size="small" @click="currentValue = false" :disabled="loading">取 消</wf-button> -->
        <wf-button size="small" @click="addTaskCheck"  :disabled="!isDisabled || loading" :loading="loading">确 定</wf-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import api from '@/services/api/customKey/customKey';
import apiTask from '@/services/api/task/task';
import TaskTitle from './taskTitle'
import FormTemp from './formTemp'
import { uuid } from '@/libs'
import { mapActions, mapState } from 'vuex'
export default {
  props: {
    value: Boolean,
    project_id: [Number, String],
    task_list_id: [Number, String],
    pid: 0
  },
  components: {
    TaskTitle,
    FormTemp,
  },
  data() {
    return {
      taskId: '',
      form: {
        task_name: '',
        sort_rule_id: 2,
        task_stage: '未开始',
        executor: {},
        start_time: '',
        end_time: '',
        task_members: []
      },
      memberList: [],
      viewLoading: false,
      editData: {
        edit_permission: true
      },
      template_id: '',
      tableTemplate: [],
      sortList: [],
      timeRange: [],
      loading: false
    }
  },
  watch: {
    timeRange() {
      if (this.timeRange.length > 0) {
        this.form.start_time = this.timeRange[0]
        this.form.end_time = this.timeRange[1]
      } else {
        this.form.start_time = ''
        this.form.end_time = ''
      }
    },
  },
  computed: {
    ...mapState('template/template', {
      dataset: state => state.dataset
    }),
    currentValue: {
      get: function () {
        if (this.value) {
          this.getFromRules()
        }
        return this.value || undefined;
      },
      set: function (newValue) {
        this.$emit('input', newValue || null)
      }
    },
    parentId() {
      return ''
    },
    parentExecutorUid() {
      return ''
    },
    lockUid() {
      return this.form.executor.uid ? [this.form.executor.uid] : []
    },
    isDisabled() {
      return Boolean(this.form.task_name)
    }
  },
  methods: {
    async getFromRules() {
      this.viewLoading = true
      await this.getTaskSortList() // 获取优先级
      this.viewLoading = false
    },
    getTaskSortList() {
      return apiTask.getTaskSortList({ sort_rule_type_id: 1 }).then(res => {
        this.sortList = res.reverse()
      })
    },
    getTempConfig(item) {
      let params = {
        ...item.component_config_in_template,
        component_desc_in_template: item.component_desc_in_template,
        component_name_in_template: item.component_name_in_template,
        component_code: item.component_code
      }
      return params
    },
    getTemplateDefaultValue(item) {
      return item.component_config_in_template && item.component_config_in_template.default_values ? item.component_config_in_template.default_values : ''
    },
    getketText(item, filter) {
      let strKey = item.component_code
      let text = strKey + '-id-' + item.component_name_in_template
      if (filter && !item.component_config_in_template.is_require) {
        return ''
      }
      return text
    },
    changeRunMan(item) { // 添加执行人时自动把执行人添加到参与人中
      if (!this.form.task_members || this.form.task_members.length === 0 || !(this.form.task_members.find(res => res.uid === item.uid))) {
        this.form.task_members.push(item)
      }
    },
    addTaskCheck() {
      this.loading = true
      let standard_components_values = []
      for (let key in this.form) {
        if (key.indexOf('TaskComponent') > -1 && (this.form[key] || this.form[key] === null || this.form[key] === 0 || this.form[key] === '')) {
          let arr = key.split('-id-')
          standard_components_values.push({
            component_code:arr?.[0],
            component_name_in_template: arr?.[1],
            component_value: this.form[key] === null || this.form[key].length === 0 ? '' : this.form[key],
          })
        }
      }
      let params = {
        id: uuid(),
        sort_rule_name: this.sortList.find(res => res.id === this.form.sort_rule_id)?.sort_name,
        task_name: this.form.task_name || '',
        standard_components_values,
        children: [],
        association_dependency: {
          post_tasks: [],
          pre_tasks: []
        }
      }

      if (this.form.start_time) {
        params.start_time = this.form.start_time
        params.end_time = this.form.end_time
      } else {
        params.start_time = ''
        params.end_time = ''
      }
      if (this.form.start_time) {
        params.start_time = this.form.start_time
        params.end_time = this.form.end_time
      }
      this.$emit('change', params)
    }
  }
}
</script>
<style lang="scss">
.add-task {
  .task-dialog {
    .tip-gre {
      background-color: #EDEDED;
      color: rgba(32, 32, 32, 0.6);
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      font-size: 14px;
    }
    .el-dialog__body {
      height: calc(100% - 144px);
    }
    .el-dialog__footer {
      height: 54px;
      padding: 11 16px;
      box-sizing: border-box;
      border-top: 1px solid rgba(32, 32, 32, 0.08);
      .cancel {
        margin-right: 24px;
      }
    }
  }
}
</style>
